export default __webpack_public_path__ + "static/media/banner_home.106dd607.png";